"use client";

import React from "react";

import { useTranslations } from "next-intl";

import { PlanCard } from "@/widgets/PlanCard";
import { RecommendedList } from "@/widgets/RecommendedList";

interface PlanRecommendationsProps {
  recommended: any[];
  recommendedLink?: string;
  locale: string;
  slug: string;
  propertyData?: any;
  completedDate?: {
    quartal: number;
    year: number;
  };
  className?: string;
}

export default function PlanRecommendations({
  recommended,
  recommendedLink,
  locale,
  slug,
  propertyData,
  completedDate,
  className,
}: PlanRecommendationsProps) {
  const t = useTranslations();

  if (!recommended || recommended.length === 0) {
    return null;
  }

  return (
    <RecommendedList
      recommended={recommended}
      title={t("Similar layouts")}
      recommendedLink={recommendedLink}
      className={className}
    >
      {(item, index) => (
        <PlanCard
          key={item._id || index}
          layout={item}
          locale={locale}
          slug={slug}
          location={propertyData?.location}
          completedDate={completedDate}
        />
      )}
    </RecommendedList>
  );
}